// Test function for autopay error reporting
// Use in browser console: testAutopayError()

import errorReporter from './errorReporting';

const testAutopayError = async () => {
  console.log('🧪 Testing autopay error reporting...');
  
  try {
    // Simulate a subscription setup failure
    const testError = new Error('Test autopay setup failure - this is a simulation');
    
    await errorReporter.reportAutopayError(testError, {
      action: 'subscription_setup_test',
      user_id: 'test_user_123',
      square_customer_id: 'TEST_CUSTOMER_ID',
      selected_card: 'test_card',
      error_details: { 
        category: 'PAYMENT_METHOD_ERROR',
        detail: 'Test error for monitoring validation' 
      },
      severity: 'critical'
    });
    
    console.log('✅ Test autopay error reported successfully!');
    console.log('📱 Check your Telegram for the alert (if in production)');
    
    return true;
  } catch (error) {
    console.error('❌ Failed to report test autopay error:', error);
    return false;
  }
};

// Also test a tokenization error
const testTokenizationError = async () => {
  console.log('🧪 Testing tokenization error reporting...');
  
  try {
    const testError = new Error('Test card tokenization failure - this is a simulation');
    
    await errorReporter.reportAutopayError(testError, {
      action: 'card_tokenization_test',
      user_id: 'test_user_456',
      square_customer_id: 'TEST_CUSTOMER_ID_2',
      token_status: 'FAILED',
      severity: 'high'
    });
    
    console.log('✅ Test tokenization error reported successfully!');
    
    return true;
  } catch (error) {
    console.error('❌ Failed to report test tokenization error:', error);
    return false;
  }
};

// Make functions available globally for console testing
window.testAutopayError = testAutopayError;
window.testTokenizationError = testTokenizationError;

export { testAutopayError, testTokenizationError };